window.iAdvizeInterface = window.iAdvizeInterface || [];
window.iAdvizeInterface.config = {
  sid: 10371,
};

window.iAdvizeInterface.push(function (iAdvize) {
  iAdvize.set('customData', {
    product_id: window.productId, // Identifiant unique du produit, uniquement sur les pages produits
  });
});
